export default __webpack_public_path__ + "static/media/paypal_logo.782bea45.png";